import config from '@/config/prod.env';
import header from '@/helper/header';
import common from '@/helper/common';

const mainUrl = `${process.env.VUE_APP_AUTH_API_URL}/Roles`;

export default {  
    getAll: async () => {
        const requestOptions = {
            method: 'POST',
            headers: await header.authHeaderWithToken(),
            body: JSON.stringify({
                "actionCode": 22,
                "appId": process.env.VUE_APP_ID
            })
        };
    
        let rs = await fetch(`${mainUrl}/QueryData`, requestOptions);
        return await common.handleResponse(rs);
    },

    // getAll: async () => {
    //     const requestOptions = {
    //         method: 'GET',
    //         headers: await header.authHeaderWithToken(),
    //     };
    
    //     let rs = await fetch(`${mainUrl}/GetAll`, requestOptions);
    //     return await common.handleResponse(rs);
    // },

    // getAllPaging: async (params) => {
    //     const requestOptions = {
    //         method: 'POST',
    //         headers: await header.authHeaderWithToken(),
    //         body: JSON.stringify({ 
    //             "currentPage": params.currentPage,
    //             "perPage": (params.perPage)? params.perPage : config.DEFAULT_LIMIT,
    //             "sortBy": (params.sortBy)? params.sortBy: "0",
    //             "orderDesc": params.sortDesc,
    //             "searchkey": (params.searchKey)? params.searchKey: ""
    //         })
    //     };
    
    //     let rs = await fetch(`${mainUrl}/GetAllPaging`, requestOptions);
    //     return await common.handleResponse(rs);
    // },
}